import gsap from 'gsap'
import Lenis from 'lenis'
import { useLenisStore } from '~/stores/LenisStore'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default function () {
  const store = useLenisStore()
  const { isMobile } = useDevice()

  const lenis: Lenis = new Lenis({
    duration: isMobile ? 1 : 1.5,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    wheelMultiplier: 1
  })

  store.lenis = lenis

  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  store.lenis.on('scroll', ScrollTrigger.update)

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000) // Convert time from seconds to milliseconds
  })

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  // gsap.ticker.lagSmoothing(0);
}
